import { Button, CircularProgress, Stack, TextField } from "@mui/material";
// import "./Register.css";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar,enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";

import IP from "../ipConfig.json";
import {useHistory,Link,Redirect} from "react-router-dom";

import "./Register.css";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const url=config.endpoint+"/auth/register";
  const [registerDetails, setRegisterDetails] = useState({
    loading: false,
    username: "",
    password: "",
    confirmPassword: "",
    redirectToReferrer:false
  });
  const history=useHistory();
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const {username,password,confirmPassword,redirectToReferrer}=registerDetails;
  const handleChange=name=>event=>{
    setRegisterDetails({...registerDetails,[name]:event.target.value})
  }
  const register = async (formData) => {
    setRegisterDetails({...registerDetails,loading:true})
    let isValid=false;
    formData.preventDefault();
    console.log(registerDetails);
    isValid=validateInput({username,password,confirmPassword});
    if(isValid)
    {
      await axios.post(config.endpoint+"/auth/register", JSON.stringify({
        username: registerDetails.username,
        password: registerDetails.password
      }), {
        headers: {
          'content-type': 'application/json'
        }
    })
    .then((res)=>{
      console.log("Registered successfully");
      setRegisterDetails({...registerDetails,loading:false,redirectToReferrer:true});
      enqueueSnackbar("Registered successfully",
          {
            variant: 'success',
          });
          // redirectUser();
          history.push("/login",{from:"Register"})
      })
    .catch((err)=>{
      // console.log("err:status",err.response.status);
        if (err.response)
        {
          if(err.response.status===400)
          {
            console.log(err.response.data.message);
            setRegisterDetails({...registerDetails,loading:false})
            enqueueSnackbar(err.response.data.message,
              {
                variant: "error"
              });
          }
          else
          {
            console.log("Something went wrong. Check that the backend is running, reachable and returns valid JSON.")
            setRegisterDetails({...registerDetails,loading:false})
            enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
            {
              variant: "error"
            });
          }
        }
      })
      // setRegisterDetails({...registerDetails,loading:false})
      setRegisterDetails({...registerDetails,username: "",
        password: "",
        confirmPassword: ""})
    }
    setRegisterDetails({...registerDetails,loading:false})
  };


  const redirectUser=()=>{
    if(redirectToReferrer){
      return <Redirect to="/login" />
    }
}
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = ({username,password,confirmPassword}) => {
    let flag=true;
    if(username==="")
    {
      console.log("Username is a required field")
            enqueueSnackbar("Username is a required field",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    if(username.length<6)
    {
      console.log("Username must be at least 6 characters")
            enqueueSnackbar("Username must be at least 6 characters",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    if(password==="")
    {
      console.log("Password is a required field")
            enqueueSnackbar("Password is a required field",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    if(password.length<6)
    {
      console.log("Password must be at least 6 characters")
            enqueueSnackbar("Password must be at least 6 characters",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    if(password!==confirmPassword)
    {
      enqueueSnackbar("Passwords do not match",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    return flag;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={registerDetails.username}
            onChange={handleChange('username')}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={registerDetails.password}
            onChange={handleChange('password')}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={registerDetails.confirmPassword}
            onChange={handleChange('confirmPassword')}
          />
          
          {registerDetails.loading && <CircularProgress className="progress"/>}
          {!registerDetails.loading && <Button className="button" variant="contained" onClick={register}>
            Register Now
           </Button>}
          <p className="secondary-action">
            Already have an account?{" "}
             {/* <a className="link" href="#">
              Login here
             </a> */}
             <Link to="/login">Login here</Link>
          </p>
        </Stack>
      </Box>
      <Footer/>
      {/* {redirectUser()} */}
    </Box>
  );
};

export default Register;
